module.exports = __webpack_public_path__ + "img/xls.d451c295.png";